import { render, staticRenderFns } from "./chatMain.vue?vue&type=template&id=09fdd3fe&"
import script from "./chatMain.vue?vue&type=script&lang=js&"
export * from "./chatMain.vue?vue&type=script&lang=js&"
import style0 from "./chatMain.vue?vue&type=style&index=0&id=09fdd3fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports